import { jsx as _jsx } from "react/jsx-runtime";
import { EventBus } from '@catawiki/runtime-toolkit';
import { Button } from '@catawiki/cata-style';
export const SignUpLink = ({ label }) => {
    const handleOnClick = (event) => {
        event.preventDefault();
        EventBus.showScreen({
            screen: EventBus.Screen.SIGN_UP,
        });
    };
    return (_jsx(Button, { variant: "tertiary", type: "button", onClick: handleOnClick, color: "info", children: label }));
};
//# sourceMappingURL=SignUpLink.js.map